/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { getRequest, delRequest, putRequest } from "../../axiosRoutes/index";
import {
  Button,
  Box,
  CircularProgress,
  Typography,
  FormControl,
  InputLabel,
  OutlinedInput,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableFooter,
  Pagination,
  IconButton,
  TableRow,
  DialogActions,
  DialogContentText,
  DialogContent,
  DialogTitle,
  Dialog,
  Snackbar,
  Alert,
  Card,
  CardContent,
  CardActions,
  useMediaQuery,
} from "@mui/material";
import SideNavBar from "../sidebar/SideNav";
import HrSideNavBar from "../sidebar/HrSideNavBar";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useSnackbar } from "../../axiosRoutes/snackbarConfig";
import AddLeave from "./AddLeave";
import { useInView } from "react-intersection-observer";

const AdminLeaves = () => {
  const { snackbar, showSnackbar, handleSnackbarClose } = useSnackbar();
  const [hover, setHover] = useState(null);
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const [leaveType, setLeaveType] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [leaves, setLeaves] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [action, setAction] = useState("");
  const [comments, setComments] = useState("");
  const [deleteId, setDeleteId] = useState(null);
  const [updateId, setUpdateId] = useState(null);
  const [leaveId, setLeaveId] = useState(null);
  const [openLeave, setOpenLeave] = useState(false);
  const role = localStorage.getItem("role");
  const [leaveData, setLeaveData] = useState({
    name: "",
    email:"",
    type: "",
    reason: "",
    duration: "",
    status: "",
    comments: "",
    startDate: "",
    endDate: "",
  });
  const [page, setPage]= useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [isFetchingLeaves, setIsFetchingLeaves] = useState(false)
  const { ref, inView } = useInView({
    threshold: 0,
  });
  const [limit, setLimit] = useState(10)

  useEffect(() => {
      if (inView) {
        if (limit < totalPages * 10) {
            setLimit((prev) => prev + 10);
        }
      }
    }, [inView]);
  
  const fetchLeaveType = async () => {
    try {
      const response = await getRequest("filter/leave");
      const statusArray = Object.keys(response).map((key) => ({
        label: key,
        value: response[key],
      }));
      setLeaveType(statusArray);
    } catch (error) {
      console.error("Error fetching type:", error);
    }
  };

  const fetchStatus = async () => {
    try {
      const response = await getRequest("filter/status");
      const statusArray = Object.keys(response).map((key) => ({
        label: key,
        value: response[key],
      }));
      setStatuses(statusArray);
    } catch (error) {
      console.error("Error fetching Filter:", error);
    }
  };

  const fetchLeaves = async () => {
    const access = localStorage.getItem("access");
    try {
      setIsFetchingLeaves(true)
      !isSmallScreen && setLoading(true)
      const response = await getRequest(`admin/leave`, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
        params: !isSmallScreen ? {page:page} : {limit: limit}
      });
      setIsFetchingLeaves(false)
      setTotalPages(response?.totals?.total_pages)
      const result = response?.data
      const formattedLeaves = result.map((leave) => {
        if (leave) {
          const startDate = new Date(leave.startDate);
          leave.startDate = startDate.toLocaleDateString("en-GB");
          const endDate = new Date(leave.endDate);
          leave.endDate = endDate.toLocaleDateString("en-GB");
        }
        const typeObj = leaveType.find((type) => type.value === leave.type);
        leave.type = typeObj ? typeObj.label : leave.type;
        const statusObj = statuses.find(
          (status) => status.value === leave.status
        );
        leave.status = statusObj ? statusObj.label : leave.status;
        return leave;
      });
      setLeaves(formattedLeaves)
    } catch (error) {
      console.error("Error fetching Leaves:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=>{
    fetchStatus()
    fetchLeaveType()
  }, [page, limit])

  useEffect(() => {
    if (leaveType.length > 0 && statuses.length > 0) {
      fetchLeaves();
    }
  }, [leaveType, statuses]);

  const handleDelete = async () => {
    try {
      const access = localStorage.getItem("access");
      const response = await delRequest(`admin/leave/${deleteId}`, access);
      fetchLeaves();
      handleClose();
      showSnackbar(response, "success");
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "An error occurred";
      showSnackbar(errorMessage, "error");
    }
  };

  const handleClickOpen = (id) => {
    setDeleteId(id);
    setOpen(true);
  };

  const handleOpen = () => {
    setOpenModal(true);
  };

  const handleStatusOpen = (id, newStatus) => {
    setUpdateId(id);
    setAction(newStatus);
    setOpenStatus(true);
  };

  const handleLeaveAction = async () => {
    try {
      const access = localStorage.getItem("access");
      await putRequest(
        `admin/leave/${updateId}`,
        {
          Authorization: `Bearer ${access}`,
        },
        {
          status: action,
          comments: comments,
        }
      );
      fetchLeaves();
      handleClose();
      showSnackbar(`Leave ${action === "approved" ? "Approved" : "Rejected"} Successfully`, "success");
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "An error occurred";
      showSnackbar(errorMessage, "error");
    }
  };

  const selectLeave = (id) => {
    setUpdateId(id);
    handleOpen();
  };

  const handleLeave = (id) => {
    setOpenLeave(true);
    setLeaveId(id);
  };

  useEffect(() => {
    const fetchLeave = async () => {
      if (leaveId !== null) {
        const access = localStorage.getItem("access");
        try {
          setLoading(true);
          const response = await getRequest(`admin/leave/${leaveId}`, {
            headers: {
              Authorization: `Bearer ${access}`,
            },
          });
          const formatStartDate = new Date(response.startDate)
            .toISOString()
            .split("T")[0];
          const formatEndDate = new Date(response.endDate)
            .toISOString()
            .split("T")[0];
            let returnStatus = () => {
              return statuses.find(
                        (status) => status.value === response.status
                    )?.label
            }
            let returnType = () => {
              return leaveType.find(
                        (type) => type.value === response.type
                    )?.label
            }
          setLeaveData({
            name: response.name,
            email: response.email,
            reason: response.reason,
            status: returnStatus(),
            type: returnType(),
            duration: response.duration,
            comments: response.comments||"N/A",
            startDate: formatStartDate,
            endDate: formatEndDate,
          });
        } catch (error) {
          console.error("Error fetching Leave:", error);
        } finally {
          setLoading(false);
        }
      } else {
        setLeaveData({
          type: "",
          name: "",
          email:"",
          startDate: "",
          endDate: "",
          duration: "",
          comments: "",
          reason: "",
          status: "",
        });
      }
    };
    fetchLeave();
  }, [leaveId]);

  const handleClose = () => {
    setOpenModal(false);
    setOpen(false);
    setOpenLeave(false);
    setOpenStatus(false);
    setAction("");
    setComments("");
    setLeaveId(null);
    setDeleteId(null);
    setUpdateId(null);
    fetchLeaves();
  };

  const headingTableCellStyle = {
    color: "#fff",
    textAlign: "center",
    borderBottom: "2px solid #1F1F1F",
    fontSize: { xs: "0.8rem", sm: "1rem" },
    backgroundColor: "#1F1F1F",
  };

  const dataTableCellStyle = (hover, id) => {
    return {
      color: hover === id ? "#FF5722" : "#fff",
      textAlign: "center",
      borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
      fontSize: { xs: "0.8rem", sm: "1rem" },
      padding: "10px 16px",
      backgroundColor: "#292929",
    };
  };

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        textAlign="center"
      >
        <CircularProgress size={50} sx={{ color: "#FF5722" }} />
        <Typography variant="h6" sx={{ marginTop: "18px", color: "#fff" }}>
          Loading...
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <div className="app-container" style={{ color: "#fff", display: "flex" }}>
        {role === "admin" && <SideNavBar />}
        {role === "hr" && <HrSideNavBar />}
        <div style={{ flex: 1, margin: `${isSmallScreen ? '3rem' : '0.5rem'} 0.5rem 0.5rem 0.5rem` }}>
          <Box sx={{ backgroundColor: "#000", marginTop: { xs: 1, md: 0 } }}>
            <Grid
              container
              sx={{
                alignItems: "center",
                justifyContent: { xs: "center", md: "space-between" },
                flexDirection: { xs: "column", md: "row" },
                padding: "1rem",
              }}
            >
              <Grid item>
                <h1>Employees Leaves</h1>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  onClick={handleOpen}
                  sx={{
                    backgroundColor: "#fff",
                    color: "black",
                    "&:hover": {
                      backgroundColor: "#e1e1e1",
                    },
                  }}
                >
                  Add Leave
                </Button>
              </Grid>
            </Grid>
            {leaves.length === 0 ? (
              <Typography variant="h6" sx={{ color: "#fff", textAlign: "center" }}>
                No Data Yet
              </Typography>
            ) : (
              <>
                {!isSmallScreen ? (
                  <TableContainer sx={{ overflowX: "auto", maxWidth: "100vw" }}>
                    <Table
                      style={{
                        borderRadius: "25px",
                        borderCollapse: "separate",
                        overflow: "hidden",
                      }}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell style={headingTableCellStyle}>
                            ID
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Name
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Email
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Type
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Reason
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Comments
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Duration
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Start Date
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            End Date
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Status
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Action
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {leaves.map((leave, id) => (
                          <TableRow
                            key={id}
                            style={{
                              cursor: "pointer",
                              height: "60px",
                            }}
                            onMouseEnter={() => setHover(id)}
                            onMouseLeave={() => setHover(null)}
                            onClick={() => handleLeave(leave._id)}
                          >
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {(page - 1) * 10 + id + 1}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {leave.name}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {leave.email}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {leave.type}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {leave.reason}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {leave.comments || "N/A"}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {leave.duration}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {leave.startDate}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {leave.endDate}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {leave.status}
                            </TableCell>
                            <TableCell
                              style={{
                                color: hover === id ? "#FF5722" : "#fff",
                                textAlign: "right",
                                borderBottom:
                                  "1px solid rgba(255, 255, 255, 0.2)",
                                fontSize: { xs: "0.8rem", sm: "1rem" },
                                padding: "10px 16px",
                                backgroundColor: "#292929",
                              }}
                            >
                              {leave.status === "Pending" && (
                                <>
                                  <IconButton
                                    style={{
                                      color: "#fff",
                                      backgroundColor: "#4CAF50",
                                      marginRight: "5px",
                                    }}
                                    aria-label="approve"
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleStatusOpen(leave._id, "approved")
                                    }}
                                  >
                                    <DoneIcon fontSize="inherit" />
                                  </IconButton>
                                  <IconButton
                                    style={{
                                      color: "#fff",
                                      backgroundColor: "#f44336",
                                      marginRight: "5px",
                                    }}
                                    aria-label="reject"
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleStatusOpen(leave._id, "rejected")
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                </>
                              )}
                              {leave.status === "Approved" && (
                                <IconButton
                                  style={{
                                    color: "#fff",
                                    backgroundColor: "#f44336",
                                    marginRight: "5px",
                                  }}
                                  aria-label="reject"
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleStatusOpen(leave._id, "rejected")
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              )}
                              {leave.status === "Rejected" && (
                                <IconButton
                                  style={{
                                    color: "#fff",
                                    backgroundColor: "#4CAF50",
                                    marginRight: "5px",
                                  }}
                                  aria-label="approve"
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleStatusOpen(leave._id, "approved")
                                  }}
                                >
                                  <DoneIcon fontSize="inherit" />
                                </IconButton>
                              )}
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#1976D2",
                                  marginRight: "5px",
                                }}
                                aria-label="view"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleLeave(leave._id)}}
                              >
                                <VisibilityIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#4CAF50",
                                  marginRight: "5px",
                                }}
                                aria-label="edit"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  selectLeave(leave._id)}}
                              >
                                <EditIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#F44336",
                                  marginRight: "5px",
                                }}
                                aria-label="delete"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClickOpen(leave._id)}}
                              >
                                <DeleteIcon fontSize="inherit" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <TableFooter style={{ backgroundColor: "#1F1F1F" }}>
                        <TableRow>
                          <TableCell
                            colSpan={100}
                            style={{
                              color: "white",
                              border: "none",
                              textAlign: "center",
                            }}
                          >
                            <Pagination
                              count={totalPages}
                              variant="outlined"
                              color="primary"
                              page={page}
                              onChange={(e, value) => {
                                setPage(value);
                              }}
                              sx={{
                                display: "inline-block",
                                "& .MuiPaginationItem-root": {
                                  color: "#fff",
                                  borderColor: "#fff",
                                  transition: "all 0.3s ease",
                                  "&:hover": {
                                    backgroundColor: "#FF5722",
                                    color: "#fff",
                                    borderColor: "#FF5722",
                                  },
                                  "&.Mui-selected": {
                                    backgroundColor: "#FF5722",
                                    color: "#fff",
                                    borderColor: "#FF5722",
                                  },
                                },
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                ) : (
                  <Grid container spacing={1} justifyContent='center'>
                    {leaves.map((leave, id) => (
                      <Grid item xs={12} key={id}>
                        <Card ref = {id+1 ===leaves.length ? ref : null}
                          sx={{
                            backgroundColor: "#101010",
                            color: "#fff",
                          }}
                          onMouseEnter={() => setHover(id)}
                          onMouseLeave={() => setHover(null)}
                          onClick={() => handleLeave(leave._id)}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <CardContent>
                              <Typography variant="h6">
                                {leave.name}
                              </Typography>
                              <Typography variant="body2">
                                Reason: {leave.reason}
                                <br />
                                Duration: {leave.duration}
                                <br />
                                Status: {leave.status}
                              </Typography>
                            </CardContent>
                            <CardActions>
                              {leave.status === "Pending" && (
                                <>
                                  <IconButton
                                    style={{
                                      color: "#fff",
                                      backgroundColor: "#4CAF50",
                                      marginRight: "1px",
                                    }}
                                    aria-label="approve"
                                    size="medium"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleStatusOpen(leave._id, "approved")
                                    }}
                                  >
                                    <DoneIcon fontSize="inherit" />
                                  </IconButton>
                                  <IconButton
                                    style={{
                                      color: "#fff",
                                      backgroundColor: "#f44336",
                                      marginRight: "1px",
                                    }}
                                    aria-label="reject"
                                    size="medium"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleStatusOpen(leave._id, "rejected")
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                </>
                              )}
                              {leave.status === "Approved" && (
                                <IconButton
                                  style={{
                                    color: "#fff",
                                    backgroundColor: "#f44336",
                                    marginRight: "1px",
                                  }}
                                  aria-label="reject"
                                  size="medium"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleStatusOpen(leave._id, "rejected")
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              )}
                              {leave.status === "Rejected" && (
                                <IconButton
                                  style={{
                                    color: "#fff",
                                    backgroundColor: "#4CAF50",
                                    marginRight: "1px",
                                  }}
                                  aria-label="approve"
                                  size="medium"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleStatusOpen(leave._id, "approved")
                                  }}
                                >
                                  <DoneIcon fontSize="inherit" />
                                </IconButton>
                              )}
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#1976D2",
                                  marginRight: "1px",
                                }}
                                aria-label="view"
                                size="medium"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleLeave(leave._id)}}
                              >
                                <VisibilityIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#4CAF50",
                                  marginRight: "1px",
                                }}
                                aria-label="edit"
                                size="medium"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  selectLeave(leave._id)}}
                              >
                                <EditIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#F44336",
                                  marginRight: "1px",
                                }}
                                aria-label="delete"
                                size="medium"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClickOpen(leave._id)}}
                              >
                                <DeleteIcon fontSize="inherit" />
                              </IconButton>
                            </CardActions>
                          </Box>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                )}
              </>
            )}
          </Box>
          <Dialog
            open={openLeave}
            maxWidth
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#212121",
                opacity: 0.9,
                color: "#fff",
                padding: "5px",
                maxWidth: { xs: "90%", md: "40%" },
                border: "2px solid #D0521B",
              },
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "22px",
                fontWeight: "bold",
              }}
            >
              {leaveData.name}
              <IconButton
                onClick={handleClose}
                sx={{
                  color: "#fff",
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Grid container justifyContent="space-between" alignItems="center" sx={{ borderTop: "2px solid #D0521B", paddingTop: "1rem", }}>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Employee name:</b> {leaveData.name}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Employee Email:</b> {leaveData.email}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Leave Type:</b> {leaveData.type}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Reason:</b> {leaveData.reason}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Duration:</b> {leaveData.duration}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Comments:</b> {leaveData.comments}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Start Date:</b> {leaveData.startDate}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>End Date:</b> {leaveData.endDate}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Status:</b> {leaveData.status}
                  </Typography>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
          <Dialog
            open={open}
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#212121",
                color: "#fff",
                padding: "15px",
              },
              "& .MuiDialogTitle-root": {
                padding: "5px",
              },
              "& .MuiDialogContentText-root": {
                color: "#fff",
              },
              "& .MuiDialogContent-root": {
                padding: "5px",
              },
              "& .MuiDialogActions-root": {
                padding: "5px",
              },
            }}
          >
            <DialogTitle>Confirm Deletion</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are You Sure You Want to Delete this Leave Application?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleClose}
                sx={{
                  backgroundColor: "#A6A6A6",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#B8B8B8" },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleDelete}
                sx={{
                  backgroundColor: "#E5622D",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#D0521B" },
                }}
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            maxWidth="sm"
            open={openStatus}
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#212121",
                color: "#fff",
                padding: "20px",
                borderRadius: "8px",
              },
              "& .MuiDialogTitle-root": {
                padding: "10px 5px",
                borderBottom: "1px solid #E5622D",
              },
              "& .MuiDialogContent-root": {
                padding: "10px",
              },
              "& .MuiDialogActions-root": {
                padding: "10px 5px",
                justifyContent: "space-around",
              },
            }}
          >
            <DialogTitle
              sx={{
                typography: "h6",
                marginBottom: "10px",
                fontWeight: "bold",
                color: "#E5622D",
              }}
            >
              Confirm Leave Status Update
            </DialogTitle>
            <DialogContent>
              <FormControl
                variant="outlined"
                fullWidth
                sx={{
                  mb: 1,
                  mt: 1,
                  "& .MuiOutlinedInput-root": {
                    color: "#FEFEFE",
                    "& fieldset": {
                      borderColor: "#FEFEFE",
                    },
                    "&:hover fieldset": {
                      borderColor: "#FEFEFE",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#FEFEFE",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#FEFEFE",
                  },
                }}
              >
                <InputLabel htmlFor="outlined-adornment-Comments">
                  Comments
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-comments"
                  type="text"
                  name="comments"
                  label="Comments"
                  value={comments}
                  onChange={(e) => setComments(e.target.value)}
                  sx={{ backgroundColor: "transparent" }}
                />
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleClose}
                sx={{
                  backgroundColor: "#A6A6A6",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#B8B8B8" },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleLeaveAction}
                sx={{
                  backgroundColor: "#E5622D",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#D0521B" },
                  "&.Mui-disabled": {
                    backgroundColor: "#EC916C",
                    color: "#fff",
                  },
                }}
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
          <AddLeave
            open={openModal}
            leaveId={updateId}
            handleClose={handleClose}
          />
        </div>
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {isSmallScreen && <Grid container width='100%' height='10vh' alignItems='center' justifyContent='center' style={{position: 'fixed', bottom: (isFetchingLeaves ? '20px' : '-100px'), transition: 'bottom 0.5s ease'}}>
                    <CircularProgress size="3rem" sx={{color: "#FF5722"}} />
                  </Grid>}
    </>
  );
};

export default AdminLeaves;
